module.exports = __webpack_public_path__ + "381136e464a965b520adc2bd8b245908.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/ZW.svg
// module id = wvM8
// module chunks = 0